import useAccounts from "./useAccounts";
import { useMemo } from "react";
function findRouteGroupForAcct(id, { deceased, live }) {
    for (const set of [deceased, live]) {
        for (const group of set) {
            for (const account of group.accounts) {
                if (account.id === id) {
                    return group;
                }
            }
        }
    }
    return null;
}
export default function useAccount(acctId) {
    const { loading, error, accts } = useAccounts();
    const acct = useMemo(() => ((!loading && findRouteGroupForAcct(acctId, accts)) || null), [loading, acctId, accts]);
    return {
        loading,
        error,
        acct,
        notFound: !loading && error == null && acct == null // loaded successfully, but acctId isn't found
    };
}



// WEBPACK FOOTER //
// ./src/assets/scripts/hooks/useAccount.ts